// Decorative serape stripe band (full-width divider)
export const SerapeBand = ({ className = '' }) => (
  <div className={`serape-band w-full ${className}`} aria-hidden="true" />
);

// Small serape underline accent placed under headings
export const SerapeUnderline = ({ className = '' }) => (
  <div className={`serape-underline ${className}`} aria-hidden="true" />
);
